import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((f) => ({
    '@type': 'Question',
    name: f.question,
    acceptedAnswer: { '@type': 'Answer', text: f.answer },
  })),
};

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>(faqItems[0].id);

  return (
    <section id="faq" className="scroll-mt-16 bg-background-100 py-14 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}></script>
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
            <i className="ri-question-line text-sm"></i> 常见问题
          </span>
          <h2 className="heading-font mt-4 text-2xl font-bold text-foreground-950 md:text-4xl">你可能还想了解</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            关于平台定位、信息可信度与更新机制，我们都放在这里一一说明。
          </p>
        </div>
        <div className="mt-10 space-y-3">
          {faqItems.map((f) => {
            const open = openId === f.id;
            return (
              <div key={f.id} className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${open ? 'border-primary-200' : 'border-background-200'}`}>
                <button
                  type="button"
                  onClick={() => setOpenId(open ? '' : f.id)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="heading-font text-sm font-bold text-foreground-950 md:text-base">{f.question}</span>
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all ${open ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'}`}>
                    <i className={open ? 'ri-subtract-line text-lg' : 'ri-add-line text-lg'}></i>
                  </span>
                </button>
                {open && <div className="border-t border-background-100 px-5 py-4 text-sm leading-relaxed text-foreground-600">{f.answer}</div>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}